import React from 'react';
import AnimateHeight from 'react-animate-height';
import { defineMessages, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/custom-theme-button';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import * as styles from './styledPanel';
var i18n = defineMessages({
  collapse: {
    id: 'bitbucket.panel-collapse.message',
    defaultMessage: 'collapse',
    description: 'Label on the panel to signal that the user can collapse the panel.'
  },
  expand: {
    id: 'bitbucket.panel-expand.message',
    defaultMessage: 'expand',
    description: 'Label on the panel to signal that the user can expand the panel.'
  }
});
var PanelStateless = function PanelStateless(_ref) {
  var children = _ref.children,
    header = _ref.header,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    onChange = _ref.onChange;
  var intl = useIntl();
  var i18nExpandText = intl.formatMessage(i18n.expand);
  var i18nCollapseText = intl.formatMessage(i18n.collapse);
  return /*#__PURE__*/React.createElement(styles.PanelWrapper, null, /*#__PURE__*/React.createElement(styles.PanelHeader, {
    onClick: function onClick() {
      return onChange(!isExpanded);
    }
  }, /*#__PURE__*/React.createElement(styles.ButtonWrapper, {
    isHidden: isExpanded
  }, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    "aria-expanded": isExpanded,
    spacing: "none",
    iconBefore: isExpanded ? /*#__PURE__*/React.createElement(ChevronDownIcon, {
      label: i18nCollapseText
    }) : /*#__PURE__*/React.createElement(ChevronRightIcon, {
      label: i18nExpandText
    })
  })), /*#__PURE__*/React.createElement("span", null, header)), /*#__PURE__*/React.createElement(AnimateHeight, {
    duration: 200,
    easing: "linear",
    height: isExpanded ? 'auto' : 0,
    className: "panel-content"
  }, children));
};
export default PanelStateless;